import { render, staticRenderFns } from "./menberFk.vue?vue&type=template&id=283e202e&"
import script from "./menberFk.vue?vue&type=script&lang=js&"
export * from "./menberFk.vue?vue&type=script&lang=js&"
import style0 from "./menberFk.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports